export default __webpack_public_path__ + "static/media/o2.a78be75f.svg";